module.exports = __webpack_public_path__ + "static/media/INTERNAL_TRANSFER_REPORT.6e91f021.svg";